import { NotFound } from '@/features/errors';

const PageNotFound = () => {
  return <NotFound />;
};

export default PageNotFound;
